export const digitalMarketingAfrica = {
  id: 2,
  title: "Digital Marketing in Africa: Strategies for Success in a Unique Market",
  author: {
    name: "Sarah van der Merwe",
    role: "Digital Marketing Strategist",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80"
  },
  date: "March 12, 2024",
  readTime: "15 min read",
  category: "Marketing",
  image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80",
  excerpt: "A comprehensive guide to digital marketing strategies that work in the diverse and dynamic African market.",
  content: `
    Digital marketing in Africa presents unique challenges and opportunities that require a deep understanding of local contexts while leveraging global best practices. This comprehensive guide explores the strategies, trends, and approaches that are proving successful in Africa's diverse digital landscape.

    Understanding the African Digital Landscape

    Market Demographics
    Africa's digital market is characterized by:
    - A young, mobile-first population
    - Varying levels of digital literacy
    - Diverse linguistic and cultural contexts
    - Different stages of digital infrastructure development
    Understanding these factors is crucial for developing effective marketing strategies.

    // ... rest of the content ...
  `
}; 